<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> deleted user <strong>{{ $_.get(activity, "payload.name")-->
<!--        }}</strong>.-->
        <span v-html="$t('notification.userRemoved', {user: $_.get(activity, 'actorUser.name'), oldUser: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "UserRemoved",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
